// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-dialog .accordion.download-targets {
  overflow-y: auto;
}

.download-dialog .main-content,
.download-dialog .mobile.layout {
  display: flex;
  flex-direction: column;
}

.download-dialog .main-content .list {
  overflow-y: auto;
  overflow-x: hidden;
}

.download-dialog .content > div,
.download-dialog .ui.grid .column,
.download-dialog .main-content {
  height: 100%;
}

.download-dialog .download-handler {
  display: flex;
  align-items: baseline;
}

.download-dialog .disk-info {
  color: black;
  font-size: 90%;
  font-style: italic;
}

.download-dialog .normal.layout .four.wide.column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/components/download/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC","sourcesContent":[".download-dialog .accordion.download-targets {\n  overflow-y: auto;\n}\n\n.download-dialog .main-content,\n.download-dialog .mobile.layout {\n  display: flex;\n  flex-direction: column;\n}\n\n.download-dialog .main-content .list {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.download-dialog .content > div,\n.download-dialog .ui.grid .column,\n.download-dialog .main-content {\n  height: 100%;\n}\n\n.download-dialog .download-handler {\n  display: flex;\n  align-items: baseline;\n}\n\n.download-dialog .disk-info {\n  color: black;\n  font-size: 90%;\n  font-style: italic;\n}\n\n.download-dialog .normal.layout .four.wide.column {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
